<template>
  <div class="home">
    <page-header header="Notifications" subheader="View all notifications." />
    <div class="flex flex-wrap lg:flex-no-wrap mb-6">
      <div class="w-full px-1 pb-2">
        <panel class="w-full">
          <notification-list :limit="50"></notification-list>
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Notifications'
}
</script>
